import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { PMTemplate } from "../../../services/Template/pm-template";
import { Api } from "../../../services/api";
import { FaCopy } from "react-icons/fa";
import { InputTextarea } from "primereact/inputtextarea";
import html2canvas from 'html2canvas';

const JOB_AUTOPSY = ({ pmId }) => {
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    const [projectData, setProjectData] = useState([]);
    const [isCopyBtnLoading, setIsCopyBtnLoading] = useState(false);


    const toast = useRef(null);

    const formik = useFormik({
        initialValues: {
            projectId: '',
            address: '',
            dateOfMeeting: '',
            whoIsPresentForAutospy: '',
            projectManager: '',
            interiorDesigner: '',
            foreman: '',
            projectSummary: '',
            testimonial: '',
            comments: '',


            // Section 16
            wins: '',
            losses: '',
            whatDidWeDoWell: '',
            WhereCouldWeMakeImprovements: '',
            WhatTradesWereExcellentAndWhy: '',
            WhatTradesWereAProblemAndWhy: '',

            // secton 17
            ProjectManager_1: '',
            PMPOINTS_1: '',
            VPPOINTS_1: '',
            PMCOMMENTS_1: '',
            VPCOCOMMENTS_1: '',
            ProjectManager_2: '',
            PMPOINTS_2: '',
            VPPOINTS_2: '',
            PMCOMMENTS_2: '',
            VPCOCOMMENTS_2: '',
            ProjectManager_3: '',
            PMPOINTS_3: '',
            VPPOINTS_3: '',
            PMCOMMENTS_3: '',
            VPCOCOMMENTS_3: '',
            ProjectManager_4: '',
            PMPOINTS_4: '',
            VPPOINTS_4: '',
            PMCOMMENTS_4: '',
            VPCOCOMMENTS_4: '',
            ProjectManager_5: '',
            PMPOINTS_5: '',
            VPPOINTS_5: '',
            PMCOMMENTS_5: '',
            VPCOCOMMENTS_5: '',
            ProjectManager_6: '',
            PMPOINTS_6: '',
            VPPOINTS_6: '',
            PMCOMMENTS_6: '',
            VPCOCOMMENTS_6: '',
            // secton 18

            ConstructionBestPratices: '',
            ConstructionChallenges: '',
            EnergyPerformanceDocument: '',
            SelectionOfMaterialsAndResources: '',
            EnergyAndWaterSavingConsiderations: '',
            InnovationAndDesign: '',
            SensitivityToSiteConditions: '',
            AnyDetailsNotMentionedAbove: '',
            SalesAndMarketingMaterial: '',
        },
        validate: (data) => {

        },

        onSubmit: (data) => {

            if (!existPageWithoutSave) {
                return;

            }
            console.log("data");
            console.log(data);


            data.user_id = localStorage.getItem('user_id');
            data.role_id = localStorage.getItem('role_id');
            // var url = Api.API_BASE_URL + 'pm-template/create';
            var url = Api.API_BASE_URL + 'job-autospy/save';

            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    setExistPageWithoutSave(false);
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });

                        // getUser();
                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });


        }
    });

    const [existPageWithoutSave, setExistPageWithoutSave] = useState(false);

    useEffect(() => {
        //getProjectDetails();

        if (pmId != 0) {

            formik.setFieldValue('projectId', pmId)
            getProjectDetails(pmId)
        }
        return () => {
            // Cleanup tasks before the component is unmounted
            console.log('cleanup');

            // if (window.confirm('Do you want to save changes you made to this document?')) {
            formik.handleSubmit();
            // }

        };
    }, []);


    const getProjectDetails = (id) => {
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        // fetch.
        fetch(Api.API_BASE_URL + 'job-autospy/get/' + id, {
            method: "GET",
            headers: headers

        })
            .then((response) => response.json())
            .then((response) => {

                if (response.error == '') {
                    console.log(response);

                    formik.setFieldValue(`address`, response.result.address);
                    formik.setFieldValue(`dateOfMeeting`, response.result.dateOfMeeting);
                    formik.setFieldValue(`whoIsPresentForAutospy`, response.result.whoIsPresentForAutospy);
                    formik.setFieldValue(`projectManager`, response.result.projectManager);
                    formik.setFieldValue(`interiorDesigner`, response.result.interiorDesigner);
                    formik.setFieldValue(`foreman`, response.result.foreman);
                    formik.setFieldValue(`projectSummary`, response.result.projectSummary);
                    formik.setFieldValue(`testimonial`, response.result.testimonial);
                    formik.setFieldValue(`comments`, response.result.comments);


                    //* ---------------------

                    if (response.playbooks_autopsy_wins != null) {
                        formik.setFieldValue(`wins`, response.playbooks_autopsy_wins.wins);
                        formik.setFieldValue(`losses`, response.playbooks_autopsy_wins.losses);
                        formik.setFieldValue(`whatDidWeDoWell`, response.playbooks_autopsy_wins.whatDidWeDoWell);
                        formik.setFieldValue(`WhereCouldWeMakeImprovements`, response.playbooks_autopsy_wins.WhereCouldWeMakeImprovements);
                        formik.setFieldValue(`WhatTradesWereExcellentAndWhy`, response.playbooks_autopsy_wins.WhatTradesWereExcellentAndWhy);
                        formik.setFieldValue(`WhatTradesWereAProblemAndWhy`, response.playbooks_autopsy_wins.WhatTradesWereAProblemAndWhy);
                    }

                    if (response.playbooks_autopsy_pm_points != null) {
                        //? ---------------------
                        formik.setFieldValue(`PMPOINTS_1`, response.playbooks_autopsy_pm_points.PMPOINTS_1);
                        formik.setFieldValue(`VPPOINTS_1`, response.playbooks_autopsy_pm_points.VPPOINTS_1);
                        formik.setFieldValue(`PMCOMMENTS_1`, response.playbooks_autopsy_pm_points.PMCOMMENTS_1);
                        formik.setFieldValue(`VPCOCOMMENTS_1`, response.playbooks_autopsy_pm_points.VPCOCOMMENTS_1);
                        //? ---------------------
                        formik.setFieldValue(`PMPOINTS_2`, response.playbooks_autopsy_pm_points.PMPOINTS_2);
                        formik.setFieldValue(`VPPOINTS_2`, response.playbooks_autopsy_pm_points.VPPOINTS_2);
                        formik.setFieldValue(`PMCOMMENTS_2`, response.playbooks_autopsy_pm_points.PMCOMMENTS_2);
                        formik.setFieldValue(`VPCOCOMMENTS_2`, response.playbooks_autopsy_pm_points.VPCOCOMMENTS_2);
                        //? ---------------------
                        formik.setFieldValue(`PMPOINTS_3`, response.playbooks_autopsy_pm_points.PMPOINTS_3);
                        formik.setFieldValue(`VPPOINTS_3`, response.playbooks_autopsy_pm_points.VPPOINTS_3);
                        formik.setFieldValue(`PMCOMMENTS_3`, response.playbooks_autopsy_pm_points.PMCOMMENTS_3);
                        formik.setFieldValue(`VPCOCOMMENTS_3`, response.playbooks_autopsy_pm_points.VPCOCOMMENTS_3);
                        //? ---------------------
                        formik.setFieldValue(`ProjectManager_5`, response.playbooks_autopsy_pm_points.ProjectManager_5);
                        formik.setFieldValue(`PMPOINTS_5`, response.playbooks_autopsy_pm_points.PMPOINTS_5);
                        formik.setFieldValue(`VPPOINTS_5`, response.playbooks_autopsy_pm_points.VPPOINTS_5);
                        formik.setFieldValue(`PMCOMMENTS_5`, response.playbooks_autopsy_pm_points.PMCOMMENTS_5);
                        formik.setFieldValue(`VPCOCOMMENTS_5`, response.playbooks_autopsy_pm_points.VPCOCOMMENTS_5);
                        //? ---------------------
                        formik.setFieldValue(`ProjectManager_6`, response.playbooks_autopsy_pm_points.ProjectManager_6);
                        formik.setFieldValue(`PMPOINTS_6`, response.playbooks_autopsy_pm_points.PMPOINTS_6);
                        formik.setFieldValue(`VPPOINTS_6`, response.playbooks_autopsy_pm_points.VPPOINTS_6);
                        formik.setFieldValue(`PMCOMMENTS_6`, response.playbooks_autopsy_pm_points.PMCOMMENTS_6);
                        formik.setFieldValue(`VPCOCOMMENTS_6`, response.playbooks_autopsy_pm_points.VPCOCOMMENTS_6);
                    }
                    //* ---------------------
                    if (response.playbooks_autopsy_wins != null) {
                        formik.setFieldValue(`ConstructionBestPratices`, response.playbooks_autopsy_construction.ConstructionBestPratices);
                        formik.setFieldValue(`ConstructionChallenges`, response.playbooks_autopsy_construction.ConstructionChallenges);
                        formik.setFieldValue(`EnergyPerformanceDocument`, response.playbooks_autopsy_construction.EnergyPerformanceDocument);
                        formik.setFieldValue(`SelectionOfMaterialsAndResources`, response.playbooks_autopsy_construction.SelectionOfMaterialsAndResources);
                        formik.setFieldValue(`EnergyAndWaterSavingConsiderations`, response.playbooks_autopsy_construction.EnergyAndWaterSavingConsiderations);
                        formik.setFieldValue(`InnovationAndDesign`, response.playbooks_autopsy_construction.InnovationAndDesign);
                        formik.setFieldValue(`SensitivityToSiteConditions`, response.playbooks_autopsy_construction.SensitivityToSiteConditions);
                        formik.setFieldValue(`AnyDetailsNotMentionedAbove`, response.playbooks_autopsy_construction.AnyDetailsNotMentionedAbove);
                        formik.setFieldValue(`SalesAndMarketingMaterial`, response.playbooks_autopsy_construction.SalesAndMarketingMaterial);

                    }
                }
                setIsLoading(false);

            })
            .catch((error) => {
                console.error("Error:", error);
                setIsLoading(false);
            });
    }

    //! -----------------------
   

    const cellStyle = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
    };

    const cellStyleW = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: 'white',
        paddingTop: '5px'
    };


    //! ----------------------------------------------------------

    const renderTextArea = (fieldName, placeholder, maxLine = 2, formData = '') => (
        <textarea
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            rows={maxLine}
            value={formData != '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none',  color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px' }}
        ></textarea>
    );

    const renderTextAreaFull = (fieldName, placeholder, maxLine = 2, formData = '',) => (
        <InputTextarea
            placeholder={placeholder}
            name={fieldName}
            autoResize
            id={fieldName}
            rows={maxLine}
            value={formData !== '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                console.log(e.target.value)
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none',  color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px' }}
        ></InputTextarea>
    );


    const renderInputArea = (fieldName, placeholder, type = 'text', formData = '') => {
        if (type == 'date') {

            if (formData != null) {
                let timestamp = new Date(formData);



                if (!isNaN(timestamp.getTime())) {
                    formData = timestamp.toISOString().split('T')[0];
                }
            }
        }
        return (
            <input
                type={type}
                placeholder={placeholder}
                name={fieldName}
                id={fieldName}
                value={formik.values[fieldName]}
                onChange={(e) => {
                    setExistPageWithoutSave(true);
                    formik.setFieldValue(fieldName, e.target.value);
                    console.log(fieldName);
                    if (fieldName === 'sitePrep_P_B_C_Date') {
                        console.log('Testing');
                        formik.setFieldValue('scheduleConstructionStartDate', e.target.value);
                    }
                    if (fieldName === 'turnOver_C_F_C_Date') {
                        formik.setFieldValue('scheduleProjectCompletion', e.target.value);
                    }
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                    }
                }}
                style={{
                    width: '100%',
                    height: '40px',
                    boxSizing: 'border-box',
                    border: 'none',
                    textAlign: 'center',
                    marginTop: '0px',
                }}
            />
        )
    };

    const renderSelect = (fieldName, formdata = '') => {
        var val = (formdata != '') ? formdata : formik.values[fieldName];
        console.log('val', val);

        return <select
            name={fieldName}
            id={fieldName}
            value={formdata !== '' ? formdata : formik.values[fieldName]}
            className={'select-text-color-' + val}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value);
            }}
            style={{ width: '100%', textAlign: 'center', color: 'white', backgroundColor: '#ff0000', border: 'none', height: '34px' }}
        >
            <option value="N">No</option>
            <option value="Y">Yes</option>
        </select>

    };
    const renderSelect1 = (fieldName, formdata = '') => {
        var val = (formdata != '') ? formdata : formik.values[fieldName];
        console.log('val', val);

        return <select
            name={fieldName}
            id={fieldName}
            value={formdata !== '' ? formdata : formik.values[fieldName]}
            className={'select-text-color-' + val}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value);
            }}
            style={{ width: '100%', textAlign: 'center', color: 'white', backgroundColor: '#ff0000', border: 'none', height: '45px', }}
        >
            <option value="N">No</option>
            <option value="Y">Yes</option>
        </select>

    };

    //! ----------------------------------------------------------
    //* -------------------------

    const elementRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),


    ];

    //* -------------------------

    return (
        <>
            {isLoading ? (
                <div className="loading-spinner">
                    Loading...
                    <div className="spinner"></div>
                </div>
            ) : (
                <form onSubmit={formik.handleSubmit} className="pm-template-form">
                    <div className="flex d-flex justify-content-end top-button submitbutton ">

                        <Button className="m-2 mx-4 p-2 px-4 d-flex align-items-center customSave-button" type="submit">
                            <strong className="mr-2">Save</strong>
                            <i className="pi pi-save"></i>
                        </Button>
                    </div>


                    <Toast ref={toast} />
                    <div className="cardd" style={{ border: 'none', }}>
                        <Accordion multiple activeIndex={[0, 1, 2, 3]}>

                            <AccordionTab header="JOB AUTOPSY" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th className="headerStyle"  style={{  width: "400px" }}>

                                                </th>
                                                <th className="headerStyle" style={{  minWidth: "auto" }}>
                                                    Job Autopsy
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={cellStyle}>Address:</td>
                                                <td style={cellStyleW}>{renderTextAreaFull(`address`, '')}</td>
                                            </tr>
                                            <tr>
                                                <td style={cellStyle}>Date of Meeting</td>
                                                <td style={cellStyleW} className="px-4">{renderInputArea(`dateOfMeeting`, '', 'date')}</td>
                                                {/* <td style={cellStyleW}>{renderTextArea(`dateOfMeeting`, '')}</td> */}
                                            </tr>
                                            <tr>
                                                <td style={cellStyle}>Who is present for Autopsy</td>
                                                <td style={cellStyleW}>{renderTextArea(`whoIsPresentForAutospy`, '')}</td>
                                            </tr>
                                            <tr>
                                                <td style={cellStyle}>Project Manager</td>
                                                <td style={cellStyleW}>{renderTextArea(`projectManager`, '')}</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStyle}>Interior Designer</td>
                                                <td style={cellStyleW}>{renderTextArea(`interiorDesigner`, '')}</td>
                                            </tr>
                                            <tr>
                                                <td style={cellStyle}>Foreman</td>
                                                <td style={cellStyleW}>{renderTextArea(`foreman`, '')}</td>
                                            </tr>
                                            <tr>
                                                <td style={cellStyle}>Project Summary:</td>
                                                <td style={cellStyleW}>{renderTextArea(`projectSummary`, '')}</td>
                                            </tr>
                                            <tr>
                                                <td style={cellStyle}>Did the Client Provide a Testimonial:</td>
                                                <td className="">
                                                    <td style={{ ...cellStyleW, minWidth: '100px', borderRight: '2px solid #DDDFE2', marginRight: '5px' }}>{renderSelect1(`testimonial`, '')}</td>
                                                    <td style={{ ...cellStyleW, width: '62vw' }}> {renderTextAreaFull(`comments`, 'comments',)}</td>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                   

                                </div>
                            </AccordionTab>

                            {/* Section 16 */}
                            <AccordionTab header="OVER ALL PREFORMANCE" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[0]}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th className="headerStyle" style={{  minWidth: "80vw" }}>
                                                    Over All Performance
                                                </th>

                                            </tr>
                                            <tr>
                                                <th className="headerStyle" style={{  textAlign: 'left' }}>
                                                    Wins:
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`wins`, '')}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th className="headerStyle" style={{  textAlign: 'left' }}>
                                                    Losses:
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`losses`, '')}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th className="headerStyle" style={{  textAlign: 'left' }}>
                                                    What did we do well?
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`whatDidWeDoWell`, '')}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th  className="headerStyle" style={{  textAlign: 'left' }}>
                                                    Where could we make improvements?  Who is accountable to ensure the change is implemented?
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`WhereCouldWeMakeImprovements`, '')}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th className="headerStyle" style={{  textAlign: 'left' }}>
                                                    What trades were excellent and why?  How are we going to recognize our trades for going above and beyond for our clients?
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`WhatTradesWereExcellentAndWhy`, '')}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th className="headerStyle" style={{ textAlign: 'left' }}>
                                                    What trades were a problem and why?  What was done about it?  Who is following up with trade?
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`WhatTradesWereAProblemAndWhy`, '')}
                                                </td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </AccordionTab>

                            {/* Section 17 */}
                            <AccordionTab header="PROJECT MANAGER & ID PERFORMANCE BONUS MEASURABLES PER PROJECT" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th className="headerStyle" style={{ minWidth: "600px", }}>
                                                    Project Manager & ID Performance Bonus Measurables Per Project:  30 points
                                                </th>
                                                <th className="headerStyle" style={{ minWidth: "150px" }}>
                                                    PM Points
                                                </th>
                                                <th className="headerStyle" style={{ minWidth: "150px" }}>
                                                    VP Points
                                                </th>
                                                <th className="headerStyle" style={{ minWidth: "200px" }}>
                                                    PM/ID Comments
                                                </th>
                                                <th className="headerStyle" style={{ minWidth: "450px" }}>
                                                    VP Construction Ops Comments
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={cellStyle}>

                                                    <strong>1. TURN OVER DEFICIENCIES:</strong>  Was the final walk through signed off by the client with 5 deficiences?  Was the project book on site, a client orientation conducted, and a gift provided by the LIDA Homes Team?  Was the home ready and clean for Key Day turn over? 1-10 points.

                                                </td>
                                                <td style={cellStyleW}>{renderInputArea('PMPOINTS_1', '', '')}</td>
                                                <td style={cellStyleW}>{renderInputArea('VPPOINTS_1', '', '')}</td>
                                                <td style={cellStyleW}> {renderTextAreaFull('PMCOMMENTS_1', '')}</td>
                                                <td style={cellStyleW}> {renderTextAreaFull('VPCOCOMMENTS_1', '')}</td>

                                            </tr>

                                            <tr>
                                                <td style={cellStyle}>

                                                    <strong>2.  ERRORS & OMMISSIONS:</strong>   Did LIDA Homes have to write anything off as a result of mistakes by the PM or ID?  Were all of the ID plans correct with accurate measurements.  Loosing the company over $1000 zero points. 1-10 points

                                                </td>
                                                <td style={cellStyleW}>{renderInputArea('PMPOINTS_2', '', '')}</td>
                                                <td style={cellStyleW}>{renderInputArea('VPPOINTS_2', '', '')}</td>
                                                <td style={cellStyleW}> {renderTextAreaFull('PMCOMMENTS_2', '')}</td>
                                                <td style={cellStyleW}> {renderTextAreaFull('VPCOCOMMENTS_2', '')}</td>

                                            </tr>

                                            <tr>
                                                <td style={cellStyle}>

                                                    <strong>3.  CLIENT SATISFACTION MONTHLY VP CON OPS CHECK AND NET PROMOTER SCORE:</strong>  What is the overall average score for the BT Client Satisfaction over the term of the project?  1-10 points

                                                </td>
                                                <td style={cellStyleW}>{renderInputArea('PMPOINTS_3', '', '')}</td>
                                                <td style={cellStyleW}>{renderInputArea('VPPOINTS_3', '', '')}</td>
                                                <td style={cellStyleW}> {renderTextAreaFull('PMCOMMENTS_3', '')}</td>
                                                <td style={cellStyleW}> {renderTextAreaFull('VPCOCOMMENTS_3', '')}</td>

                                            </tr>



                                            <tr>
                                                <td style={cellStyleW}> {renderTextAreaFull('ProjectManager_5', '')}</td>
                                                <td style={cellStyleW}>{renderInputArea('PMPOINTS_5', '', '')}</td>
                                                <td style={cellStyleW}>{renderInputArea('VPPOINTS_5', '', '')}</td>
                                                <td style={cellStyleW}> {renderTextAreaFull('PMCOMMENTS_5', '')}</td>
                                                <td style={cellStyleW}> {renderTextAreaFull('VPCOCOMMENTS_5', '')}</td>

                                            </tr>

                                            <tr>
                                                <td style={cellStyleW}> {renderTextAreaFull('ProjectManager_6', '')}</td>
                                                <td style={cellStyleW}>{renderInputArea('PMPOINTS_6', '', '')}</td>
                                                <td style={cellStyleW}>{renderInputArea('VPPOINTS_6', '', '')}</td>
                                                <td style={cellStyleW}> {renderTextAreaFull('PMCOMMENTS_6', '')}</td>
                                                <td style={cellStyleW}> {renderTextAreaFull('VPCOCOMMENTS_6', '')}</td>

                                            </tr>



                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            {/* Section 18 */}
                            <AccordionTab header="CONSTRUCTION DETAILS - AWARD INFO" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th className="headerStyle" style={{ minWidth: "80vw" }}>
                                                    Construction Details - Award Info
                                                </th>

                                            </tr>
                                            <tr>
                                                <th className="headerStyle" style={{  textAlign: 'left' }}>
                                                    Construction Best Pratices (general) - point form:
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`ConstructionBestPratices`, '')}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th className="headerStyle" style={{ textAlign: 'left' }}>
                                                    Construction Challenges - point form:
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`ConstructionChallenges`, '')}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th className="headerStyle" style={{ textAlign: 'left' }}>
                                                    Energy Performance Document (ensure test results document is availble in the project files in Work File and/or Buildertrend):
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`EnergyPerformanceDocument`, '')}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th className="headerStyle" style={{ textAlign: 'left' }}>
                                                    Special Features for Energy Efficiency - point form:
                                                </th>
                                            </tr>

                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`SelectionOfMaterialsAndResources`, 'Selection of materials and resources (heating systems, high-efficiency materials like lighting, appliances etc):')}

                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`EnergyAndWaterSavingConsiderations`, 'Energy and water-saving considerations, waste reduction - in the home and during construction:')}

                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`InnovationAndDesign`, 'Innovation and Design:')}

                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`SensitivityToSiteConditions`, 'Sensitivity to site conditions and surrounding environments')}

                                                </td>
                                            </tr>

                                            <tr>
                                                <th className="headerStyle" style={{  textAlign: 'left' }}>
                                                    Performanc Targets - Built Green, LEED, Passive House, Net-Zero details (additional to anythng above - point form:
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`AnyDetailsNotMentionedAbove`, 'Any details not mentioned above:')}

                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`SalesAndMarketingMaterial`, 'Sales and marketing material to promote energy efficiency:')}


                                                </td>
                                            </tr>

                                        </thead>

                                    </table>
                                </div>
                            </AccordionTab>

                        </Accordion>
                    </div>
                </form>
            )}
        </>
    );
};

export default JOB_AUTOPSY;
